import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { devToolsGuard } from './core/guards/dev-tools.guard';
import { TOOLS_CHILD_ROUTES } from './features/plantation/tools/tools.routes';

export const routes: Routes = [
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
    },
    {
        path: 'tools',
        canActivate: [authGuard, devToolsGuard],
        children: TOOLS_CHILD_ROUTES,
    },
    {
        path: '_tools',
        canActivate: [authGuard, devToolsGuard],
        children: TOOLS_CHILD_ROUTES,
    },
    {
        path: '',
        canActivate: [authGuard],
        loadChildren: () => import('./features/features.routes').then(m => m.FEATURES_ROUTES),
    },
];
